/* @flow */

import { clearLegacyDraftAttachmentKeys, initTabId } from './Helpers/Utils'
import React from 'react'
import ReactDOM from 'react-dom'

const mountNode = document.getElementById('request-tracker-app')

if (mountNode) {
  initTabId()
  clearLegacyDraftAttachmentKeys()
  // Fallback if a chunk fails to load (e.g. a stale cached index.html requesting
  // a hashed chunk that no longer exists after a deploy). Without this the promise
  // rejection is swallowed and the user is left with a blank page.
  const showLoadError = () => {
    mountNode.innerHTML =
      '<div style="font-family: sans-serif; padding: 40px; text-align: center; color: #333;">' +
      'Something went wrong loading the page. Please refresh to try again.' +
      '</div>'
  }

  // `typeof` guard: if a build config forgets to define ENABLE_MAINTENANCE_MODE,
  // this defaults to the normal app instead of throwing a ReferenceError (blank page).
  if (typeof ENABLE_MAINTENANCE_MODE !== 'undefined' && ENABLE_MAINTENANCE_MODE) {
    // Maintenance mode: load only the lightweight maintenance page. The main app
    // chunk (and its stores/API calls) is never fetched during down time (PTS-806).
    import('./pages/Maintenance')
      .then(({ default: Maintenance }) => {
        ReactDOM.render(<Maintenance />, mountNode)
      })
      .catch(showLoadError)
  } else {
    import('./ptsApp')
      .then(({ default: ptsApp }) => {
        ptsApp(mountNode)
      })
      .catch(showLoadError)
  }
}



// WEBPACK FOOTER //
// ./src/index.js